import { useTheme } from '@emotion/react';
import { IconChevronLeftLarge, IconChevronRightLarge } from '@hubble/icons/web';
import { Button } from '../Button/index.js';
import { Flex } from '../Flex/index.js';
import { Text } from '../Text/index.js';
import { testIds } from './testIds.js';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';

const TablePagination = ({
  loading,
  nextPage,
  previousPage,
  getCanNextPage,
  getCanPreviousPage,
  getPageCount,
  paginationState
}) => {
  const {
    translate
  } = useTheme();
  const pageCount = getPageCount();
  if (pageCount <= 1) return null;
  return jsxs(Flex, {
    m: 2,
    align: "center",
    justify: "center",
    children: [jsx(Button.Secondary, {
      display: "inline",
      size: "sm",
      disabled: !getCanPreviousPage() || loading,
      onClick: () => previousPage(),
      "aria-label": translate('Table.previousPage'),
      "data-testid": testIds.previousPaginationButton,
      icon: jsx(IconChevronLeftLarge, {})
    }), jsx(Text.Body, {
      size: "xs",
      ml: 1,
      mr: 1,
      "data-testid": testIds.paginationCounter,
      children: translate('Table.pageCount', {
        currentPage: paginationState.pageIndex + 1,
        pageCount
      })
    }), jsx(Button.Secondary, {
      display: "inline",
      size: "sm",
      disabled: !getCanNextPage() || loading,
      onClick: () => nextPage(),
      "aria-label": translate('Table.nextPage'),
      "data-testid": testIds.nextPaginationButton,
      icon: jsx(IconChevronRightLarge, {})
    })]
  });
};

export { TablePagination };
